<script>
export default {
  inheritAttrs: false,
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    label: { type: String, required: true },
    modelValue: { type: [Boolean, Array], default: false },
    link: { type: Boolean, default: false },
    value: { type: [Boolean, String, Number], default: false },
  },
  computed: {
    cboxModel: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('change', val)
      },
    },
  },
}
</script>

<template>
  <div>
    <template v-if="link">
      <div class="flex">
        <label class="normal-case mb-0" :for="$attrs.id">
          <input
            v-model="cboxModel"
            type="checkbox"
            :value="value"
            v-bind="$attrs"
            class="mr-2 leading-tight cursor-pointer"
          />
        </label>
        <div>
          <span class="block">
            {{ label }}
          </span>
          <slot></slot>
        </div>
      </div>
    </template>

    <template v-else>
      <label class="label flex normal-case mb-0" :for="$attrs.id">
        <input
          v-model="cboxModel"
          type="checkbox"
          :value="value"
          v-bind="$attrs"
          class="mr-2 leading-tight cursor-pointer"
        />
        <span class="cursor-pointer">
          {{ label }}
        </span>
      </label>
    </template>
  </div>
</template>
